// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FunnelPlotFilledSvg from "@ant-design/icons-svg/es/asn/FunnelPlotFilled";
import AntdIcon from '../components/AntdIcon';

var FunnelPlotFilled = function FunnelPlotFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FunnelPlotFilledSvg
  }));
};

FunnelPlotFilled.displayName = 'FunnelPlotFilled';
export default React.forwardRef(FunnelPlotFilled);